import type { Option } from '@/types/option'
import { httpClient } from '../../httpClient'

export type AuthorIdeaUser = Option & {
  avatar?: string
  area?: string
}

type GetAuthorIdeaUsersResponse = {
  users: AuthorIdeaUser[]
}

// todo: fazer testes
export async function getAuthorIdeaUsers(
  name: string,
): Promise<GetAuthorIdeaUsersResponse> {
  const { data } = await httpClient.get(
    `ideas/idea-users/author?search=${name}`,
  )

  return {
    users:
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      data.ideaUsers.map((ideaUser: any) => ({
        value: ideaUser.id,
        label: ideaUser.name,
        avatar: ideaUser.image,
        area: ideaUser.area,
      })) ?? [],
  }
}
